<div class="order-pricing-wrapper">
    <div class="card">
        <div class="card-header">
            <span class="pull-left"><span translate="cart.order.history.order.number"></span>&nbsp;{{orderView.id}}</span>
        </div>
        <div class="card-body order-summary">
            <span class="fw-bold" translate="cart.order.history.order.status"></span>
            <span class="text-capitalize fw-bold">{{'cart.order.history.order.status.' + orderView.status.toLowerCase() | translate}}</span>
            <span translate="cart.order.history.order.total"></span><span>{{orderView.total | usanacurrency: orderView.currencyCode | async}}</span>
            @if (displayVolume) {
                <span translate="cart.order.history.order.total.volume"></span><span>{{orderView.totalVolume}}</span>
            }
            <span translate="cart.order.history.order.source"></span>
            <span translate="{{'cart.order.history.source.' + orderView.source}}"></span>
        </div>
    </div>
    <div class="panel-action">
        @switch (trackingCount) {
            @case (0) {
                <span class="no-action"></span>
            }
            @case (1) {
                <div class="action">
                    @if (!!trackingLink) {
                        <a target="_blank" [href]="trackingLink">
                            <button type="button" class="btn btn-primary" [attr.analytics-value]="trackingNumber">
                                <span class="fw-bold" translate="cart.order.history.track.package"></span>
                                <i class="fa-solid fa-arrow-up-right-from-square margin-left-8" aria-hidden="true"></i>
                            </button>
                        </a>
                    }
                </div>
            }
            @default {
                <div class="action">
                    <a (click)="openOrderTrackingModal(orderView)">
                        <button type="button" class="btn btn-primary">
                            <span class="fw-bold" translate="cart.track.packages"></span>
                        </button>
                    </a>
                </div>
            }
        }
        @if (orderView.source === 'APO') {
            <a class="btn btn-secondary"
                    [ngClass]="{'disabled-tag': !canAutoOrder}"
                    [routerLink]="canAutoOrder ? [AUTO_ORDER_MANAGE_ROUTE] : null">
                <span class="fw-bold" translate="cart.order.history.manage.auto.order"></span>
            </a>
        }
        <span class="tooltip-wrapper"
              [tooltip]="'cart.order.history.cannot.add.order' | translate"
              [isDisabled]="canAddToCart && !isAddingToCart">
            <button type="button" class="btn btn-warning"
                    [disabled]="!canAddToCart || isAddingToCart"
                    (click)="addFullOrder.emit(orderView.products)">
                <span class="fw-bold" translate="cart.order.history.add.order.to.cart"></span>
            </button>
        </span>
    </div>
</div>
